import { PropertyType } from '@consumer/graphql'
import {
  PREFERRED_LOCATIONS,
  LOCATION_TYPE,
  preferredLocationTypes,
  preferredLocationFromString,
} from '@consumer/shared'

export { PREFERRED_LOCATIONS, LOCATION_TYPE, preferredLocationFromString }

// CWA callers that used `preferredLocations[x]` (Record<PREFERRED_LOCATIONS, LOCATION_TYPE>)
// now resolve to the shared preferredLocationTypes record.
export { preferredLocationTypes as preferredLocations }

export const preferredLocationNotSet = PREFERRED_LOCATIONS.NotSet

// CWA-specific ordering: NoPreference appears first in every list, and
// BackDoor is not offered to CWA users. These lists differ from the
// CMA-canonical baseline in packages/shared/src/utils/preferredLocations.ts.
export const preferredLocationsByPropertyType = {
  [PropertyType.House]: [
    PREFERRED_LOCATIONS.NoPreference,
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.SidePorch,
    PREFERRED_LOCATIONS.Garage,
  ],
  [PropertyType.Apartment]: [
    PREFERRED_LOCATIONS.NoPreference,
    PREFERRED_LOCATIONS.Mailroom,
    PREFERRED_LOCATIONS.PropertyStaff,
    PREFERRED_LOCATIONS.LoadingDock,
    PREFERRED_LOCATIONS.Garage,
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.SidePorch,
  ],
  [PropertyType.Business]: [
    PREFERRED_LOCATIONS.NoPreference,
    PREFERRED_LOCATIONS.Mailroom,
    PREFERRED_LOCATIONS.PropertyStaff,
    PREFERRED_LOCATIONS.LoadingDock,
    PREFERRED_LOCATIONS.Garage,
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.SidePorch,
  ],
  [PropertyType.Other]: [
    PREFERRED_LOCATIONS.NoPreference,
    PREFERRED_LOCATIONS.FrontDoor,
    PREFERRED_LOCATIONS.SidePorch,
    PREFERRED_LOCATIONS.Garage,
    PREFERRED_LOCATIONS.Mailroom,
    PREFERRED_LOCATIONS.PropertyStaff,
    PREFERRED_LOCATIONS.LoadingDock,
  ],
}
